import React, { Component, Fragment } from 'react'
import style from './style.traficLight'

// COMPONENTS
import Fab from '@material-ui/core/Fab'
import ErrorOutline from '@material-ui/icons/ErrorOutline'
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import Tooltip from '@material-ui/core/Tooltip'
import ReactHtmlParser from 'react-html-parser'

class TraficLight extends Component {
  state = {
    problems: window.state.problemsSummary,
    isActiveDataSources: window.state.hasActiveDataSources,
    isEditedStatistics: window.state.hasEditedStatistics,
    openTooltip: false,
  }

  declOfNum = (number, titles) => {
    const cases = [2, 0, 1, 1, 1, 2]
    return titles[
      number % 100 > 4 && number % 100 < 20
        ? 2
        : cases[number % 10 < 5 ? number % 10 : 5]
    ]
  }

  render() {
    const { classes } = this.props
    const {
      problems: {
        errors: { items: errors, total: totalErrors },
        warnings: { items: warnings, total: totalWarnings },
      },
      isActiveDataSources,
      isEditedStatistics,
    } = this.state

    const statusError = totalErrors ? (
      <Tooltip
        interactive
        disableFocusListener
        PopperProps={{
          disablePortal: true,
        }}
        classes={{ tooltip: classes.tooltipError, popper: classes.popper }}
        title={
          <Fragment>
            <ul className={classes.tooltipItems}>
              {errors.map(({ caption, description }) => (
                <li key={caption}>
                  <span>{caption}</span>
                  <span>{ReactHtmlParser(description)}</span>
                </li>
              ))}
            </ul>
          </Fragment>
        }
      >
        <Fab
          variant="extended"
          size="medium"
          classes={{
            root: classes.signal,
            extended: classes.statusError,
            sizeMedium: classes.signal,
          }}
        >
          <ErrorOutline className={classes.extendedIcon} />
          {`${totalErrors} `}
          {this.declOfNum(totalErrors, ['проблема', 'проблемы', 'проблем'])}
        </Fab>
      </Tooltip>
    ) : null

    const statusWarning = totalWarnings ? (
      <Tooltip
        interactive
        disableFocusListener
        PopperProps={{
          disablePortal: true,
        }}
        classes={{
          tooltip: classes.tooltipWarning,
          popper: classes.popper,
        }}
        title={
          <Fragment>
            <ul className={classes.tooltipItems}>
              {warnings.map(({ caption, description }) => (
                <li key={caption}>
                  <span>{caption}</span>
                  <span>{ReactHtmlParser(description)}</span>
                </li>
              ))}
            </ul>
          </Fragment>
        }
      >
        <Fab
          variant="extended"
          size="medium"
          classes={{
            root: classes.signal,
            extended: classes.statusWarning,
            sizeMedium: classes.signal,
          }}
        >
          <ErrorOutline className={classes.extendedIcon} />
          {`${totalWarnings} `}
          {this.declOfNum(totalWarnings, [
            'предупреждение',
            'предупреждения',
            'предупреждений',
          ])}
        </Fab>
      </Tooltip>
    ) : null

    const statusOk = !totalErrors && !totalWarnings && (
      <Fab
        variant="extended"
        size="medium"
        classes={{
          root: classes.signal,
          extended: classes.statusOk,
          sizeMedium: classes.signal,
        }}
      >
        <CheckCircleOutline className={classes.extendedIcon} />
        Все в порядке!
      </Fab>
    )

    const trafficLights = (
      <Fragment>
        {statusError}
        {statusWarning}
        {statusOk}
      </Fragment>
    )

    const noSetupCompleted = (
      <Fab
        variant="extended"
        size="medium"
        classes={{
          root: classes.signal,
          extended: classes.noSetup,
          sizeMedium: classes.signal,
        }}
        href={location.pathname === '/dashboard' ? '' : '/dashboard'}
      >
        <ErrorOutline className={classes.extendedIcon} />
        Настройка не завершена
      </Fab>
    )

    const stateOfSystem =
      isActiveDataSources || isEditedStatistics
        ? trafficLights
        : noSetupCompleted

    return <div className={classes.traficLight}>{stateOfSystem}</div>
  }
}

export default style(TraficLight)
